<template>
  <div class="result-wrapper">
    <div
      class="result-item"
      v-for="(result, index) in getFilterResult"
      :key="index"
    >
      <!-- labels -->
      <span v-if="getSupportedTypes.includes(result.type)" class="input-name">
        {{ result.name }}
      </span>

      <!-- text input types -->
      <div v-if="getTextInputType.includes(result.type)" class="value-wrapper">
        <span class="input-value">{{ result.value }}</span>
      </div>
      <!-- list input type -->
      <div v-if="getListInputType.includes(result.type)" class="value-wrapper">
        <span class="input-value">{{ JSON.stringify(result.value) }}</span>
      </div>

      <!-- object type  -->
      <div v-if="getObjectType.includes(result.type)" class="value-wrapper">
        <!-- <pre class="input-value">{{ getFormattedObject(result.value, 0) }}</pre> -->
        <span class="input-value">{{
          getFormattedObject(result.value, 0)
        }}</span>
        <!-- <span class="input-value">{{ JSON.stringify(result.value) }}</span> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AILogicInputOutput',
  props: {
    results: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    getFormattedObject(obj, level) {
      let result = '';
      const indent = '    '.repeat(level); // 4 spaces for indentation

      for (let key in obj) {
        if (typeof obj[key] === 'object' && obj[key] !== null) {
          result +=
            `${indent}${key}:\n` + this.getFormattedObject(obj[key], level + 1);
        } else {
          result += `${indent}${key}: ${obj[key]}\n`;
        }
      }
      return result;
    },
  },

  computed: {
    getFilterResult() {
      return this.results.filter((result) => result.name != 'codelosSettings');
    },

    getTextInputType() {
      return ['text', 'number', 'formatted_number', 'email', 'error', 'radio'];
    },
    getListInputType() {
      return ['list', 'checkbox'];
    },
    getObjectType() {
      return ['object', 'json'];
    },
    getSupportedTypes() {
      return [
        ...this.getTextInputType,
        ...this.getListInputType,
        ...this.getObjectType,
      ];
    },
  },
};
</script>

<style scoped>
.result-wrapper {
  padding: 16px;
  display: flex;
  gap: 4px;
  flex-direction: column;
  overflow: scroll;
  height: 100%;
}

.result-wrapper .result-item {
  display: flex;
  flex-direction: row;
  align-items: start;
  gap: 2px;
}
.result-wrapper .input-name {
  background-color: #333343;
  padding: 2px 8px;
  border-radius: 4px;
  color: #fff;
  margin-right: 4px;
}
.result-wrapper .input-value {
  color: #000;
  white-space: pre-wrap;
  padding-top: 8px;
}
.result-wrapper .value-wrapper {
  padding-top: 2px;
}
</style>
